const _console = console;
const createlog = (util) => (...args) => {
  const fun = _console[util] ? _console[util] : _console.log;
  fun.apply(void 0, args);
};

const hello = (title, version) =>
  createlog("log")(
    `%c ${title} %c ${version} `,
    "padding: 2px 1px; border-radius: 3px 0 0 3px; color: #fff; background: #606060; font-weight: bold;",
    "padding: 2px 1px; border-radius: 0 3px 3px 0; color: #fff; background: #42c02e; font-weight: bold;"
  );

hello('oa-front', '1.2.20', '5cd8272ace5c27a2289670a801a335134797af40');
